import { UserActions, UserPositions } from '@/shared/constants';
import type { IAccesses } from '@/shared/types/session.types';

/** Доступы гостя или сотрудника без сессии: всё закрыто. */
export const EMPTY_ACCESSES: IAccesses = {
  global: {
    isAdmin: false,
    isUnderwriter: false,
    isLeasingManager: false,
    isLeasingDirector: false,
    isMonitoringManager: false,
    isCarAppraiser: false
  },
  leasing: {
    canMakeDecisions: false
  }
};

/**
 * Флаги доступа сотрудника: роль — по коду должности, ручные решения по заявкам —
 * по наличию действия `UserActions.ManualDecisions` среди разрешённых.
 */
export const getAccesses = (
  positionCode: string,
  actions: number[]
): IAccesses => ({
  global: {
    isAdmin: positionCode === UserPositions.Admin,
    isUnderwriter: positionCode === UserPositions.Underwriter,
    isLeasingManager: positionCode === UserPositions.LeasingManager,
    isLeasingDirector: positionCode === UserPositions.LeasingDirector,
    isMonitoringManager: positionCode === UserPositions.MonitoringManager,
    isCarAppraiser: positionCode === UserPositions.CarAppraiser
  },
  leasing: {
    canMakeDecisions: actions.includes(UserActions.ManualDecisions)
  }
});
